import { AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const blockMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-blocked-content/myme/:mymeId'
};

export const blockAuthorAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-blocked-content/author/:authorId'
};
